import { types } from 'mobx-state-tree';

const BalancePaymentOrderUser = types.model('BalancePaymentOrderUser', {
  name: types.string,
  amount_with_tax: types.string,
  amount_without_tax: types.string
});

export default BalancePaymentOrderUser;
